import React, { useEffect, useState } from "react";

import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import IconButton from "@mui/material/IconButton";
import SaveIcon from "@mui/icons-material/Save";
import Download from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Modal, Tooltip } from "@mui/material";
import AcompanhamentoCargaGridCarregamentosCIFModalTopo from "./acompanhamentoCargaGridCarregamentosCIFModalTopo";
import AcompanhamentoCargaGridCarregamentosCIFModalDetalhe from "./acompanhamentoCargaGridCarregamentosCIFModalDetalhe";
import DownloadCSVModal from "../../../components/common/DownloadCSVModal/DownloadCSVModal";
import { GridColumns } from "@mui/x-data-grid";
import FileUpload from "../../../components/common/FileUpload";
import { confirmAlert } from "react-confirm-alert";
import Parceiro from "../../../components/classes/Parceiro";
import SkuHelper from "../../../helper/skuHelper";
import AutocompleteJustificativaCommon from "../../../components/common/AutocompleteJustificativaCommon";
import { useTranslation } from "react-i18next";

interface AcompanhamentoCargaGridCarregamentosCIFModalPropsTypes {
  handleClose: any;
  handleSalvarClick: any;
  data: any;
  setRows: any;
  fileWasUploaded: any;
  addNewCarregamento: any;
  removeCarregamento: any;
  revertRemoveCarregamento: any;
  parceiro: Parceiro
}

export default function AcompanhamentoCargaGridCarregamentosCIFModal(
  props: AcompanhamentoCargaGridCarregamentosCIFModalPropsTypes
) {
  const { t } = useTranslation();
  const [openDownloadCSVModal, setOpenDownloadCSVModal] = useState<boolean>(false);
  const [openFileDialog, setOpenFileDialog] = useState<boolean>(false);
  const [csvFoiEnviado, setCsvFoiEnviado] = useState<{wasUpdated: boolean, isSuccess: boolean, details: any}>({wasUpdated: false, isSuccess: false, details: ""});

  useEffect(() => {
    console.log(csvFoiEnviado);
    if (csvFoiEnviado.wasUpdated){
      setOpenFileDialog(false);
      props.handleClose();
      if(csvFoiEnviado.isSuccess) {
        confirmAlert({
          title: t('pages.deliveriesCif.modalTitle'),
          message: t('pages.deliveriesCif.modalDescriptionSuccess'),
          buttons: [
            {
              label: t('global.button.ok'),
              onClick: () => {
                props.fileWasUploaded();
              },
            },
          ],
        })
      }else{
        confirmAlert({
          title: t('pages.deliveriesCif.modalTitleError'),
          message: csvFoiEnviado.details.response.data,
          buttons: [
            {
              label: t('global.button.ok'),
              onClick: () => {
                props.fileWasUploaded();
              },
            },
          ],
        })
      }
    }
  }, [csvFoiEnviado]);

  const columns: GridColumns = [
      {
        field: "delete",
        headerName: t('global.table.options'),
        width: 60,
        align: "center",
        headerAlign: "center",
        renderCell: (item) => {
          return (
            <div>
            {
              !item.row.deletar ?
              <Tooltip title={t('page.deliveriesCif.tooltipShowLoadingDeliveries')}>
                <span>
                  <IconButton
                    onClick={() => props.removeCarregamento(item)}
                  >
                    <RemoveIcon />
                  </IconButton>
                </span>
              </Tooltip>
              :
              <Tooltip title={t('page.deliveriesCif.tooltipDeleteLoadingHistory')}>
                <span>
                  <IconButton
                    onClick={() => props.revertRemoveCarregamento(item)}
                  >
                    <AddIcon />
                  </IconButton>
                </span>
              </Tooltip>
            }
            </div>
          );
        },
      },
      {
        field: "id",
        headerName: "id",
        width: 60,
        align: "center",
        headerAlign: "center",
        renderHeader: (item) => {
          return <div>#</div>;
        },
        renderCell: (item) => {
          return (
            item.row.deletar ? 
            <p style={{textDecoration: "line-through"}}>
              {item.row.id < 0 ? t('global.button.new') : item.row.id}
            </p>
            :
            <p>
              {item.row.id < 0 ? t('global.button.new') : item.row.id}
            </p>
          );
        },
      },
      {
        field: "pedidoId",
        headerName: t('global.table.order'),
        type: "string",
        width: 110,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (item) => {
          return (
            item.row.deletar ? 
            <p style={{textDecoration: "line-through"}}>
              {item.row.pedidoId}
            </p>
            :
            <p>
              {item.row.pedidoId}
            </p>
          );
        },
      },
      {
        field: "item",
        headerName: t('global.table.item'),
        type: "string",
        width: 110,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (item) => {
          return (
            item.row.deletar ? 
            <p style={{textDecoration: "line-through"}}>
              {item.row.item}
            </p>
            :
            <p>
              {item.row.item}
            </p>
          );
        },
      },
      {
        field: "sku",
        headerName: "SKU",
        type: "string",
        width: 110,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (item) => {
          return (
            item.row.deletar ? 
            <p style={{textDecoration: "line-through"}}>
              {item.row.sku}
            </p>
            :
            <p>
              {item.row.sku}
            </p>
          );
        },
      },
      {
        field: "descricao",
        headerName: t('global.table.skuDescription'),
        type: "string",
        width: 240,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (item) => {
          return (
            item.row.deletar ? 
            <p style={{textDecoration: "line-through"}}>
              {SkuHelper.getSKUName(+item.row.sku)}
            </p>
            :
            <p>
              {SkuHelper.getSKUName(+item.row.sku)}
            </p>
          );
        },
      },
      {
        field: "quantidadeCarregada",
        headerName: t('global.table.loadedQuantity'),
        width: 100,
        align: "center",
        headerAlign: "center",
        editable: true,
        renderCell: (item) => {
          return (
            <p>
              {item.value ? item.value?.toString()?.replace('.', ',') : ""}
            </p>
          );
        },
      },
      {
        field: "dataCarregamento",
        headerName: t('global.table.loadingDate'),
        type: "date",
        width: 110,
        editable: true,
        align: "center",
        headerAlign: "center",
        renderCell: (item) => {
          return (
            <p>
              {new Date(item.row.dataCarregamento).toLocaleDateString("pt-BR")}
            </p>
          );
        },
      },
      {
        field: "dataEntrega",
        headerName: t('global.table.deliveryDate'),
        type: "date",
        width: 110,
        editable: true,
        align: "center",
        headerAlign: "center",
        renderCell: (item) => {
          return (
            <p>
              {new Date(item.row.dataEntrega).toLocaleDateString("pt-BR")}
            </p>
          );
        },
      },
      {
        field: "placaCarreta",
        headerName: t('global.table.truckPlate'),
        type: "string",
        width: 180,
        editable: true,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "placaCavalo",
        headerName: t('global.table.truckHorsePlate'),
        type: "string",
        width: 180,
        editable: true,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "quantidadeQuebra",
        headerName: t('global.table.breakQuantity'),
        type: "number",
        width: 180,
        editable: true,
        align: "center",
        headerAlign: "center",
        renderCell: (item) => {
          return (
            <p>
              {item.value ? item.value?.toString()?.replace('.', ',') : ""}
            </p>
          );
        },
      },
      {
        field: "justificativa",
        headerName: t('global.table.breakJustification'),
        width: 240,
        sortable: false,
        editable: true,
        renderEditCell: (gridItem) => {
          return <AutocompleteJustificativaCommon gridItem={gridItem} tipo={"Pedido"}/>
        },
      },
    ];
    
  const handleClickOpenDownloadCSV = () => {
    setOpenDownloadCSVModal(true);
  };

  const handleCloseDownloadCSVModal = () => {
    setOpenDownloadCSVModal(false);
  }

  const handleClickOpenUploadCSV = () => {
    setOpenFileDialog(true);
  }

  const handleClickCloseUploadCSV = () => {
    setOpenFileDialog(false);
  };

  function FileUploadPage() {
    return (
      <div>
        <FileUpload {...{ endpoint: `PedidoPrevisaoEntrega/AtualizarLotePorPlanilha/${props.parceiro.codigoFornecedorSAP.valueOf()}`, setCsvFoiEnviado: setCsvFoiEnviado, apiName: "Pedidos" }} />
      </div >
    )
  }

  return (
      <div className="containerForecastModal" style={{ width: "80vw" }}>
        <div className="containerTitleModal">
          <AcompanhamentoCargaGridCarregamentosCIFModalTopo />
        </div>
        <div className="containerToolbarModal">
          <Tooltip title={t('page.deliveriesCif.tooltipAddNewLoad')}>
            <span>
              <IconButton  onClick={props.addNewCarregamento}>
                <AddIcon />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={t('page.deliveriesCif.tooltipDownloadFileAndUpdate')}>
            <span>
              <IconButton  onClick={handleClickOpenDownloadCSV}>
                <Download />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={t('page.deliveriesCif.tooltipUploadFileAndUpdateList')}>
            <span>
              <IconButton onClick={handleClickOpenUploadCSV}>
                <FileUploadIcon />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={t('page.deliveriesCif.tooltipSaveChanges')}>
            <span>
              <IconButton 
                onClick={props.handleSalvarClick} 
              >
                <SaveIcon />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={t('page.deliveriesCif.tooltipExitModal')}>
            <IconButton onClick={props.handleClose}>
              <ExitToAppIcon />
            </IconButton>
          </Tooltip>
        </div>
        <div className="insiderContainerModal">
          <AcompanhamentoCargaGridCarregamentosCIFModalDetalhe
            handleClose={props.handleClose}
            data={props.data}
            setRows={props.setRows}
            columns={columns}
          />
        </div>
        <Modal
          open={openDownloadCSVModal}
          onClose={handleCloseDownloadCSVModal}
          sx={{
            display: "flex",
            "justifyContent": "center",
            "alignItems": "center",
          }}
        >
          <>
            <DownloadCSVModal
              handleClose={handleCloseDownloadCSVModal}
              rows={props.data}
              columns={columns}
              name={'Histórico de Cargas CIF'}
            />
          </>
        </Modal>

        <div>
          <Dialog
            open={openFileDialog}
            onClose={handleClickCloseUploadCSV}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Importação de Planilha Excel!"}
              <br />
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description"><br />
                {FileUploadPage()}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant="outlined"
                color="success"
                onClick={handleClickCloseUploadCSV}
                autoFocus
              >
                Fechar
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
  );
}
